import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { BlogListParamsDto } from '@models/blog';
import { HttpClient } from '@angular/common/http';
import { CardModel } from '@models/admin/schemaModels/card-schema.model';

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  private readonly http = inject(HttpClient);

  getNews(params: BlogListParamsDto) {
    return this.http.post<any>('/news/landing', params);
  }

  getNewsArticle(id: number): Observable<CardModel> {
    return this.http.post<any>('/news/landing', {
      limit: 1,
      page: 0,
      filter: [{ name: 'id', operator: 'equals', value: [id] }],
    } as BlogListParamsDto).pipe(
      map((data) => data?.news[0]),
    );
  }
}
